module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row-content-wrapper is-clearfix"
  }, [_c('div', {
    staticClass: "row-description"
  }, [_c('b-switch', {
    on: {
      "input": _vm.onChanged
    },
    model: {
      value: (_vm.mutateService.enable),
      callback: function($$v) {
        _vm.$set(_vm.mutateService, "enable", $$v)
      },
      expression: "mutateService.enable"
    }
  }, [_vm._v("\n        Скрыть блок услуги с  главной страницы сайта\n      ")]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Title"
    }
  }, [_c('b-input', {
    on: {
      "input": _vm.onChanged
    },
    model: {
      value: (_vm.mutateService.title),
      callback: function($$v) {
        _vm.$set(_vm.mutateService, "title", $$v)
      },
      expression: "mutateService.title"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "URL"
    }
  }, [_c('b-input', {
    on: {
      "input": _vm.onChanged
    },
    model: {
      value: (_vm.mutateService.url),
      callback: function($$v) {
        _vm.$set(_vm.mutateService, "url", $$v)
      },
      expression: "mutateService.url"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Description"
    }
  }, [_c('b-input', {
    on: {
      "input": _vm.onChanged
    },
    model: {
      value: (_vm.mutateService.description),
      callback: function($$v) {
        _vm.$set(_vm.mutateService, "description", $$v)
      },
      expression: "mutateService.description"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.mutateService.items), function(item, index) {
    return _c('b-field', {
      key: item,
      attrs: {
        "label": ' преимущество №' + (index + 1)
      }
    }, [_c('b-input', {
      attrs: {
        "value": item
      },
      on: {
        "input": function($event) {
          _vm.mutateService.items[index] = $event
        },
        "blur": _vm.onChanged
      }
    })], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "photo"
  }, [(!_vm.mutateService.photo) ? _c('img', {
    attrs: {
      "src": "/static/img/icons/home.svg"
    }
  }) : _c('img', {
    attrs: {
      "src": "/upload/photos/" + _vm.mutateService.photo
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.handleLoadServicePhoto
    }
  }, [_vm._v("Изменить фото")]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper centered",
    on: {
      "click": _vm.onRemove
    }
  }, [_c('a', {
    staticClass: "button is-danger"
  }, [_vm._v("-")]), _vm._v("\n      Удалить\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38a13134"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/ServiceItem.vue
// module id = 930
// module chunks = 0